<template>
    <div style="height: 100vw">
        <DiffEditor :value="modifiedCode" :original="originalCode" language="javascript"
            theme="vs-dark" height="100%" :options="editorOptions" />
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { DiffEditor } from 'monaco-editor-vue3';

const editorOptions = {
    fontSize: 14,
    minimap: {
        enabled: true
    },
    automaticLayout: true,
    originalEditable: true,

};

const originalCode = ref('const x = 1;');
const modifiedCode = ref('const x = 2;');
</script>